import { Box, Flex, HStack, Spacer, VStack } from '@chakra-ui/react';
import { ProductHighlightAdmin } from '@diamond/shared/types';
import { Text } from '@diamond/shared/ui';
import { LIST_FEATURE_FLAGS, useFeatureFlag } from '@diamond/shared/utils';

interface HighlightItemProps {
  data: Pick<
    ProductHighlightAdmin[number],
    | 'id'
    | 'title'
    | 'product_highlight_type'
    | 'total_business_types'
    | 'total_shiptos'
    | 'distribution_channel'
    | 'business_segmentation'
  >;
  ActionButton: () => JSX.Element;
}
export function HighlightItem({ data, ActionButton }: HighlightItemProps) {
  const isNewCg3 = useFeatureFlag(
    LIST_FEATURE_FLAGS.FF_HIGHLIGHT_CG3_NEW,
    false
  );
  const generalCabang = (distributionChannel: string[]) => {
    if (distributionChannel && distributionChannel.length > 0) {
      return distributionChannel.length;
    } else {
      return 'Semua';
    }
  };
  const generalTipeBisnis = (totalBusinessTypes: number) => {
    if (totalBusinessTypes && totalBusinessTypes > 0) {
      return totalBusinessTypes;
    } else {
      return 'Semua';
    }
  };
  const generalBussinesSegmentation = (businessSegmentation: string[]) => {
    if (businessSegmentation && businessSegmentation.length > 0) {
      return businessSegmentation.length;
    } else {
      return 'Semua';
    }
  };
  return (
    <Flex
      minWidth="inherit"
      alignItems="center"
      gap={4}
      justifyContent="space-between"
      w="inherit"
    >
      <Box width={300}>{data?.title}</Box>

      {isNewCg3 && (
        <VStack alignItems="flex-start">
          <Text fontWeight={600} textAlign="left" textTransform="capitalize">
            {data?.product_highlight_type || '-'}
          </Text>
          <HStack>
            <Text>{generalCabang(data?.distribution_channel)} Cabang</Text>
            <Text> • </Text>
            <Text>
              {generalTipeBisnis(data?.total_business_types)} Tipe Bisnis
            </Text>
            {isNewCg3 && (
              <>
                <Text> • </Text>
                <Text>
                  {generalBussinesSegmentation(data?.business_segmentation)}{' '}
                  Kategori
                </Text>
              </>
            )}
          </HStack>
        </VStack>
      )}
      <Spacer />
      <ActionButton />
    </Flex>
  );
}
